<template>
<div>Direct Login</div>
</template>
<script>
export default {
  data() {
    return {
      redirecURI: {},
      eserviceName: {},
      clientID: {},
      scope: {},
      state: {}
    }
  },
  mounted() {
    console.log("Direct Login created");
    this.redirectURI = this.$route.query.redirectURI;
    this.eserviceName = this.$route.query.eserviceName;
    this.clientID = this.$route.query.clientID;
    this.scope = this.$route.query.scope;
    this.state = this.$route.query.state;
    
    var url = this.redirectURI + "?eservicnName=" + this.eserviceName + "&clientID=" + this.clientID +
    "&scope=" + this.scope + "&state=" + this.state;
    window.location.assign(url);
  },
  components: {
  },
  methods: {
  }
};
</script>
<style lang="scss" scoped></style>
